import React, { useState, useEffect, useMemo, useRef, useCallback } from "react";
import { useNavigate } from 'react-router-dom';
// import "./ResultChart.css";
import "../FinalPage/FinalPage.css";


import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import axios from "axios";
import Subscriptions from "../Subscriptions/Subscriptions";
import Dashboard from '../Dashboard/Dashboard'
import dark from "../../images/dark.png"
import black from "../../images/black.png"
import darkstand from "../../images/dark-stand.png"
import darksit from "../../images/dark-sit.png"
import { END_URL, IMG_URL } from "../../config";
import ProgressBarNew from '../ProgressBarNew/ProgressBarNew';
import ResultTwo from '../ResultTwo/ResultTwo'
import ResultPageLast from '../ResultPageLast/ResultPageLast';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import ResultChart from '../ResultChart/ResultChart';
import loadimg from "../../images/pp-logo.gif"; 
import SideResult from '../SideArche/SideResult';
import asm from "../../images/ann.png";
import ResultSlider from '../ResultSlider/ResultSlider';
import { Helmet } from 'react-helmet';
import { useLocation } from "react-router-dom";

function DilemmaNoTest({ plan, onLoginChange, result, testdata, demension, globaltest,userdetail }) {

    const location = useLocation();

    const navigator = useNavigate();

    const isCalculatingMode = location.search.includes("calculating");

    const globaltestDark = globaltest?.globalTest || [];

    const chartRef = useRef(null);

    const contentRefs = useRef([]);

    const subAd = true;

    const [subscription, setSubscription] = useState(null);

    const [ShowModal, setShowModal] = useState(false);

    const [TestLink,setTestLink] = useState(null);

    const [TestLink1,setTestLink1] = useState(null);

    const [TestLink2,setTestLink2] = useState(null);

    const [test,settest] = useState([]);

    const token = localStorage.getItem('token');

    
    const subS = false;

    const { slug, test_slug } = useParams();

    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);

    const [FreeTestAttempt,setFreeTestAttempt] = useState(false);

    const [FreeTestContent,setFreeTestContent] = useState([]);

    const [showFreeSub,setshowFreeSub] = useState(false);

    const handleNavigete = (link) => {

        if (link) {
        window.location.href = `/${link}`;
        }
    };

    const handleNavigeteTest = (link) => {

        navigator(`/${link}`);
    }

    const TakeFreeSub = () => {

        setshowFreeSub(true);
    };

    const sideclass = "side-bar-dark";

      useEffect(() => {
        FetchResultData();
    }, []);

    const FetchResultData = async () => {
        const url = "result-deliemmas";

        try {
        const response = await fetch(`${END_URL}/${url}/${slug}`, {
            method: "POST",
            headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            },
        });

        const data = await response.json();

        settest(data?.test);

        setFreeTestAttempt(data?.user_attent_free_test);

        setFreeTestContent(data?.free_test);

        } catch (error) {
        console.error("Error sending result:", error);
        } finally {

            setIsLoading(false);
        }
    };   

    const handleNavigate = () => {

        navigate(`/dilemma/${slug}`);
    };

    if (isLoading) {
        return (
            <div className="loader-container">
            <img src={loadimg} alt="Loading..." className="loader-gif" />
            </div>
        );
    }
    

    return (

    <>
        <div className="dark-main">

                <>
                 
                    <div className="container-fluid dark-fluid2 darkfluid-21">

                        <div className="row">

                            <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">

                                <Dashboard globaltest={globaltest} />


                            </div>


                            <div className="col-12 col-sm-12 col-md-8 col-lg-8 dark-res">

                                <>
                                    <span className="menu-toggleBar" >
                                        <FontAwesomeIcon icon={faBars} />
                                    </span>

                                </>

                                <div className="dark-inner-outer">

                                    <>
                                        <div className="no-login-result">
                                        
                                            <div  dangerouslySetInnerHTML={{ __html: test.description || '' }} />

                                                {FreeTestAttempt ? (
                                            
                                                    <a className="button" onClick={handleNavigate} >

                                                    {test?.testdetail?.re_take_test_label} {test?.name}

                                                        <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span>
                                                        
                                                    </a>

                                                ): (

                                                    <a className="button" onClick={TakeFreeSub} >

                                                        {test?.testdetail?.re_take_test_label} {test?.name}

                                                        <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span>
                                                        
                                                    </a>

                                                )}

                                            </div>
                                    </>
                                  
                                </div>

                            </div>

                        </div>

                    </div>


                     
                    { showFreeSub  && (
                    
                            <div className={`newdashpop-overlay subs-cognit-modal1 dash-dil-12-pop`}>
                                <div className="newdashpop-inner">
                                    <div className="newdashpop-container  sub-no">
                                        <button
                                            className="newdashpop-close"
                                            onClick={() => setshowFreeSub(false)}
                                            >
                                        &times;
                                        </button>

                                        <div className="conent-pop subs-left">
                                            
                                            <div className="conent-pop-text" dangerouslySetInnerHTML={{ __html: FreeTestContent?.not_have_free_test}} />

                                            <button   onClick={() => handleNavigeteTest(FreeTestContent?.link)} >
                                            
                                                {FreeTestContent?.not_have_free_test_label}

                                            </button>

                                        </div>

                                    
                                    </div>
                                </div>
                            </div>
                    )}                           

                    {ShowModal && (
                                            
                                <div 
                            className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                            subscription?.data?.length == 1 ? "single-subscription" : ""
                            }`}
                            
                            >

                            <div className="newdashpop-inner">

                                <div className="newdashpop-container">

                                    <button
                                        className="newdashpop-close"
                                        onClick={() => setShowModal(false)}
                                        >
                                        &times;
                                    </button>

                                    <div className="conent-pop">
                                    
                                    <Subscriptions subs={subAd} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                                    </div>

                                </div>

                            </div>

                        </div>
                    )}


                </>

        </div>

        </>
    )
}

export default DilemmaNoTest